import * as React from "react";
import { IResidenceRequest, IResidenceRequestListItem } from "../../../../../models/IResidenceRequest";
import { useAuth } from "../../../../../App";
import { ResidenceRequestApi } from "../../../../../api/ResidenceRequestApi";
import { ButtonType, CustomButton, SortableTableHeader, Table } from "soprasteria-ui-library";
import { formatDate } from "../../../../../helpers/DateHelper";
import { ResidenceRequestModal } from "../../../../ResidenceRequestModal/ResidenceRequestModal";

interface IProps {
    residenceRequests: IResidenceRequestListItem[];
    canCreateNewRequest: boolean;
    onSuccess: (message: string) => void;
}

export const ResidenceRequestTable: React.FC<IProps> = ({ residenceRequests, canCreateNewRequest, onSuccess }) => {
    const auth = useAuth();
    const api = new ResidenceRequestApi(auth);

    const [renderModal, setRenderModal] = React.useState<boolean>(false);
    const [residenceRequest, setResidenceRequest] = React.useState<IResidenceRequest>();
    const abortController = new AbortController();

    React.useEffect(() => {
        if (residenceRequest) {
            setRenderModal(true);
            document.getElementById("open-residence-request-modal")?.click();
        }

        return () => {
            abortController.abort();
        }
    }, [residenceRequest]);

    const closeModal = () => {
        setRenderModal(false);
        setResidenceRequest(undefined);
    }

    const onSubmit = () => {
        document.getElementById("close-residence-request-modal")?.click();
        onSuccess("Ansökan har skapats");
    }

    const handleRowClick = (residenceRequestId: number) => {
        api.getResidenceRequestById(residenceRequestId, (data) => {
            setResidenceRequest(data);
        }, undefined, undefined);
    }

    return (
        <>
            <section>
                <div className="panel text-right">
                    {
                        canCreateNewRequest && <CustomButton buttonText="Skapa ansökan" buttonType={ButtonType.create} data-toggle="modal" data-target="#residence-request-modal" onClick={() => setRenderModal(true)} />
                    }
                </div>
                <Table hoverableRows>
                    <thead>
                        <tr>
                            <SortableTableHeader propertyToSortBy="ResidenceName" headerText="Boendenamn" />
                            <SortableTableHeader propertyToSortBy="ResidenceTypeName" headerText="Boendetyp" />
                            <SortableTableHeader propertyToSortBy="RegDate" headerText="Skapad" />
                            <SortableTableHeader propertyToSortBy="StatusName" headerText="Status" />
                            <SortableTableHeader propertyToSortBy="DecisionTypeName" headerText="Beslut" />
                        </tr>
                    </thead>
                    <tbody>
                        {
                            residenceRequests && residenceRequests.length > 0
                                ? residenceRequests.map((r, key) => {
                                    return (
                                        <tr key={key} className="clickable-row" onClick={() => handleRowClick(r.residenceRequestRequestId)}>
                                            <td>{r.residenceName}</td>
                                            <td>{r.residenceTypeName}</td>
                                            <td>{formatDate(r.regDate)}</td>
                                            <td>{r.statusName}</td>
                                            <td>{r.decisionTypeName ? r.decisionTypeName : "-"}</td>
                                        </tr>
                                    )
                                })
                                : <tr><td colSpan={5}>Det finns inga ansökningar på denna kommun/stadsdel</td></tr>
                        }
                    </tbody>
                </Table>
            </section>
            {
                renderModal ?
                    <ResidenceRequestModal residenceRequest={residenceRequest} onSubmit={onSubmit} closeModal={closeModal} />
                    : null
            }
        </>
    )
}
